import { useState } from 'react';
import { getItemInStorage } from 'utils/functions';
import getApiBaseUrl from 'config/apiBaseUrl';

const baseUrl = getApiBaseUrl();

const useApi = (path = '', initialMethod = 'GET', initialBody = null) => {
  const session = getItemInStorage('user');
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async ({
    url = path,
    method = initialMethod,
    body = initialBody,
    responseType = 'json',
    headers = {},
    throwOnError = false,
  }) => {
    setLoading(true);
    setData(null);
    setError(null);
    let result = null;
    try {
      const options = {
        method,
        headers: {
          'Content-Type': 'application/json',
          ...(session?.token && { Authorization: `Bearer ${session.token}` }),
          ...headers
        },
        body: method !== 'GET' && body ? JSON.stringify(body) : null,
      };

      const finalUrl = `${baseUrl}/${url}`;
      const response = await fetch(finalUrl, options);

      const parseJsonResponse = async () => {
        const rawText = await response.text();

        if (!rawText) {
          return null;
        }

        try {
          return JSON.parse(rawText);
        } catch (parseError) {
          return rawText;
        }
      };

      if (responseType === 'arrayBuffer') {
        result = await response.arrayBuffer();
      } else if (responseType === 'blob') {
        result = await response.blob();
      } else {
        result = await parseJsonResponse();
      }

      if (!response.ok) {
        const errorMessage =
          result?.error?.message ||
          result?.message ||
          // Forma de error de express-validator (ver checkErrors/dropRequest en
          // api/utils/functions.js): { errors: [{ msg: '...' }] }.
          result?.errors?.[0]?.msg ||
          `HTTP error! status: ${response.status}`;
        const apiError = new Error(errorMessage);
        apiError.status = response.status;
        apiError.code = result?.error?.code;
        apiError.payload = result;

        throw apiError;
      }

      setData(result);
      return result;
    } catch (e) {
      setError(e.message);
      console.error('Error fetching data:', e);
      if (throwOnError) {
        throw e;
      }
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { data, error, loading, fetchData };
};

export default useApi;
